import { createBrowserRouter, Navigate } from "react-router-dom";

import { BOARD_CODE } from "../constants";

import MainLayout from "../layouts/MainLayout";
import CommonLayout from "../layouts/CommonLayout";

import Login from "../pages/Login";
import Register from "../pages/Register";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import ContactUs from "../pages/ContactUs";

import ContactUsDetail from "../pages/ContactUs/ContactUsDetail";

import AboutUs01 from "../pages/AboutUs/AboutUs01";
import AboutUs02 from "../pages/AboutUs/AboutUs02";
import AboutUs03 from "../pages/AboutUs/AboutUs03";
import AboutUs04 from "../pages/AboutUs/AboutUs04";
import AboutUs05 from "../pages/AboutUs/AboutUs05";
import AboutUs06 from "../pages/AboutUs/AboutUs06";

import KCDH01 from "../pages/KCDH/KCDH01";
import KCDH02 from "../pages/KCDH/KCDH02";
import KCDH03 from "../pages/KCDH/KCDH03";

import MyPage01 from "../pages/MyPage/MyPage01";
import MyPage02 from "../pages/MyPage/MyPage02";
import MyPage03 from "../pages/MyPage/MyPage03";
import MyPage04 from "../pages/MyPage/MyPage04";
import MyPage05 from "../pages/MyPage/MyPage05";

import News01 from "../pages/News/List/News01";
import NewsDetail01 from "../pages/News/Detail/NewsDetail01";
import NewsUpsert01 from "../pages/News/Upsert/NewsUpsert01";
import News02 from "../pages/News/List/News02";
import NewsUpsert02 from "../pages/News/Upsert/NewsUpsert02";

import Family01 from "../pages/Family/List/Family01";
import FamilyUpsert01 from "../pages/Family/Upsert/FamilyUpsert01";
import FamilyDetail0234 from "../pages/Family/Detail/FamilyDetail0234";
import Family0234 from "../pages/Family/List/Family0234";
import FamilyUpsert0234 from "../pages/Family/Upsert/FamilyUpsert0234";
import Family05 from "../pages/Family/List/Family05";
import Family06 from "../pages/Family/List/Family06";
import FamilyUpsert06 from "../pages/Family/Upsert/FamilyUpsert06";
import FamilyDetail06 from "../pages/Family/Detail/FamilyDetail06";

import Research01 from "../pages/Research/List/Research01";
import Research02 from "../pages/Research/List/Research02";
import Research03 from "../pages/Research/List/Research03";
import ResearchDetail03 from "../pages/Research/Detail/ResearchDetail03";
import ResearchWrite03 from "../pages/Research/Upsert/ResearchWrite03";
import Research04 from "../pages/Research/List/Research04";
import ResearchDetail04 from "../pages/Research/Detail/ResearchDetail04";

import Privacy from "../pages/Privacy";
import Term from "../pages/Term";
import FindId from "../pages/FindId";
import ForgotPassword from "../pages/ForgotPassword";

const routePath = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "Home",
        element: <Navigate to="/" />,
      },
      {
        path: "",
        element: <Home />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
      // Auth
      {
        path: "Login",
        element: <Login />,
      },
      {
        path: "Register",
        element: <Register />,
      },
      {
        path: "FindId",
        element: <FindId />,
      },
      {
        path: "ForgotPassword",
        element: <ForgotPassword />,
      },

      // Contact Us
      {
        path: "ContactUs",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <ContactUs boardCode={BOARD_CODE.CONTACT} />,
          },
          {
            path: ":itemNo",
            element: <ContactUsDetail boardCode={BOARD_CODE.CONTACT} />,
          },
        ],
      },

      // About Us
      {
        path: "AboutUs",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/AboutUs/Question" />,
          },
          {
            path: "Question",
            element: <AboutUs01 />,
          },
          {
            path: "Communication",
            element: <AboutUs02 />,
          },
          {
            path: "Lifestyle",
            element: <AboutUs03 />,
          },
          {
            path: "Story",
            element: <AboutUs04 />,
          },
          {
            path: "Healthy",
            element: <AboutUs05 />,
          },
          {
            path: "Goodbye",
            element: <AboutUs06 />,
          },
        ],
      },

      // KCDH
      {
        path: "KCDH",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/KCDH/Goal" />,
          },
          {
            path: "Goal",
            element: <KCDH01 />,
          },
          {
            path: "Build",
            element: <KCDH02 />,
          },
          {
            path: "Introduction",
            element: <KCDH03 />,
          },
        ],
      },

      // My Page
      {
        path: "MyPage",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/MyPage/ChangeInfo" />,
          },
          {
            path: "ChangeInfo",
            element: <MyPage01 />,
          },
          {
            path: "ChangeEmail",
            element: <MyPage02 />,
          },
          {
            path: "ChangePassword",
            element: <MyPage03 />,
          },
          {
            path: "IdeaHistory",
            element: <MyPage04 boardCode={BOARD_CODE.RESEARCH_PROPOSAL} />,
          },
          {
            path: "IdeaHistory/:itemNo",
            element: (
              <ResearchDetail03
                parent="/MyPage/IdeaHistory"
                boardCode={BOARD_CODE.RESEARCH_PROPOSAL}
              />
            ),
          },

          {
            path: "IdeaHistory/Edit/:itemNo",
            element: (
              <ResearchWrite03
                parent="/MyPage/IdeaHistory"
                boardCode={BOARD_CODE.RESEARCH_PROPOSAL}
              />
            ),
          },
          {
            path: "Withdraw",
            element: <MyPage05 />,
          },
        ],
      },

      // News
      {
        path: "News",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/News/Notice" />,
          },
          {
            path: "Notice",
            element: <News01 boardCode={BOARD_CODE.NOTICE} />,
          },
          {
            path: "Notice/Add",
            element: <NewsUpsert01 boardCode={BOARD_CODE.NOTICE} />,
          },
          {
            path: "Notice/:itemNo",
            element: <NewsDetail01 boardCode={BOARD_CODE.NOTICE} />,
          },
          {
            path: "Notice/Edit/:itemNo",
            element: <NewsUpsert01 boardCode={BOARD_CODE.NOTICE} />,
          },
          {
            path: "AnnualReport",
            element: <News02 boardCode={BOARD_CODE.ANNUAL_REPORT} />,
          },
          {
            path: "AnnualReport/Add",
            element: <NewsUpsert02 boardCode={BOARD_CODE.ANNUAL_REPORT} />,
          },
          {
            path: "AnnualReport/Edit/:itemNo",
            element: <NewsUpsert02 boardCode={BOARD_CODE.ANNUAL_REPORT} />,
          },
        ],
      },

      // Family
      {
        path: "Family",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/Family/Faq" />,
          },
          {
            path: "Faq",
            element: <Family01 boardCode={BOARD_CODE.FAQ} />,
          },
          {
            path: "Faq/:itemNo",
            element: (
              <NewsDetail01 boardCode={BOARD_CODE.FAQ} parent="/Family/Faq" />
            ),
          },
          {
            path: "Faq/Add",
            element: <FamilyUpsert01 boardCode={BOARD_CODE.FAQ} />,
          },
          {
            path: "Faq/Edit/:itemNo",
            element: <FamilyUpsert01 boardCode={BOARD_CODE.FAQ} />,
          },
          {
            path: "ForKid",
            element: (
              <Family0234 parent="ForKid" boardCode={BOARD_CODE.BABY_CHEER} />
            ),
          },
          {
            path: "ForKid/:itemNo",
            element: (
              <FamilyDetail0234
                parent="ForKid"
                boardCode={BOARD_CODE.BABY_CHEER}
              />
            ),
          },
          {
            path: "ForKid/Add",
            element: (
              <FamilyUpsert0234
                parent="ForKid"
                boardCode={BOARD_CODE.BABY_CHEER}
              />
            ),
          },
          {
            path: "ForKid/Edit/:itemNo",
            element: (
              <FamilyUpsert0234
                parent="ForKid"
                boardCode={BOARD_CODE.BABY_CHEER}
              />
            ),
          },
          {
            path: "ForDoctor",
            element: (
              <Family0234
                parent="ForDoctor"
                boardCode={BOARD_CODE.CARE_CHEER}
              />
            ),
          },
          {
            path: "ForDoctor/:itemNo",
            element: (
              <FamilyDetail0234
                parent="ForDoctor"
                boardCode={BOARD_CODE.CARE_CHEER}
              />
            ),
          },
          {
            path: "ForDoctor/Add",
            element: (
              <FamilyUpsert0234
                parent="ForDoctor"
                boardCode={BOARD_CODE.CARE_CHEER}
              />
            ),
          },
          {
            path: "ForDoctor/Edit/:itemNo",
            element: (
              <FamilyUpsert0234
                parent="ForDoctor"
                boardCode={BOARD_CODE.CARE_CHEER}
              />
            ),
          },
          {
            path: "StarKid",
            element: (
              <Family0234
                parent="StarKid"
                boardCode={BOARD_CODE.BABY_MEMORIAL}
              />
            ),
          },
          {
            path: "StarKid/:itemNo",
            element: (
              <FamilyDetail0234
                parent="StarKid"
                boardCode={BOARD_CODE.BABY_MEMORIAL}
              />
            ),
          },
          {
            path: "StarKid/Add",
            element: (
              <FamilyUpsert0234
                parent="StarKid"
                boardCode={BOARD_CODE.BABY_MEMORIAL}
              />
            ),
          },
          {
            path: "StarKid/Edit/:itemNo",
            element: (
              <FamilyUpsert0234
                parent="StarKid"
                boardCode={BOARD_CODE.BABY_MEMORIAL}
              />
            ),
          },
          {
            path: "GeneralArchive",
            element: <Family05 boardCode={BOARD_CODE.GENERAL_RESOURCE} />,
          },
          {
            path: "GeneralArchive/:itemNo",
            element: (
              <NewsDetail01
                parent="/Family/GeneralArchive"
                boardCode={BOARD_CODE.GENERAL_RESOURCE}
              />
            ),
          },
          {
            path: "GeneralArchive/Add",
            element: (
              <NewsUpsert01
                parent="/Family/GeneralArchive"
                boardCode={BOARD_CODE.GENERAL_RESOURCE}
              />
            ),
          },
          {
            path: "GeneralArchive/Edit/:itemNo",
            element: (
              <NewsUpsert01
                parent="/Family/GeneralArchive"
                boardCode={BOARD_CODE.GENERAL_RESOURCE}
              />
            ),
          },
          {
            path: "Curious",
            element: <Family06 boardCode={BOARD_CODE.QUESTION} />,
          },
          {
            path: "Curious/:itemNo",
            element: (
              <FamilyDetail06
                parent="Curious"
                boardCode={BOARD_CODE.QUESTION}
              />
            ),
          },
          {
            path: "Curious/Add",
            element: (
              <FamilyUpsert06
                parent="Curious"
                boardCode={BOARD_CODE.QUESTION}
              />
            ),
          },
          {
            path: "Curious/Edit/:itemNo",
            element: (
              <FamilyUpsert06
                parent="Curious"
                boardCode={BOARD_CODE.QUESTION}
              />
            ),
          },
        ],
      },

      // Research
      {
        path: "Research",
        element: <CommonLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/Research/MemberBoard" />,
          },
          {
            path: "MemberBoard",
            element: <Research01 boardCode={BOARD_CODE.RESEARCH_BOARD} />,
          },
          {
            path: "MemberBoard/:itemNo",
            element: (
              <NewsDetail01
                boardCode={BOARD_CODE.RESEARCH_BOARD}
                parent="/Research/MemberBoard"
              />
            ),
          },
          {
            path: "MemberBoard/Add",
            element: (
              <NewsUpsert01
                boardCode={BOARD_CODE.RESEARCH_BOARD}
                parent="/Research/MemberBoard"
              />
            ),
          },
          {
            path: "MemberBoard/Edit/:itemNo",
            element: (
              <NewsUpsert01
                boardCode={BOARD_CODE.RESEARCH_BOARD}
                parent="/Research/MemberBoard"
              />
            ),
          },
          {
            path: "MemberArchive",
            element: <Research02 boardCode={BOARD_CODE.RESEARCH_RESOURCE} />,
          },
          {
            path: "MemberArchive/:itemNo",
            element: (
              <NewsDetail01
                boardCode={BOARD_CODE.RESEARCH_RESOURCE}
                parent="/Research/MemberArchive"
                hasVideoUrl
              />
            ),
          },
          {
            path: "MemberArchive/Add",
            element: (
              <NewsUpsert01
                boardCode={BOARD_CODE.RESEARCH_RESOURCE}
                parent="/Research/MemberArchive"
                hasVideoUrl
              />
            ),
          },
          {
            path: "MemberArchive/Edit/:itemNo",
            element: (
              <NewsUpsert01
                boardCode={BOARD_CODE.RESEARCH_RESOURCE}
                parent="/Research/MemberArchive"
                hasVideoUrl
              />
            ),
          },
          {
            path: "Idea",
            element: <Research03 boardCode={BOARD_CODE.RESEARCH_PROPOSAL} />,
          },
          {
            path: "Idea/:itemNo",
            element: (
              <ResearchDetail03
                parent="/Research/Idea"
                boardCode={BOARD_CODE.RESEARCH_PROPOSAL}
              />
            ),
          },
          {
            path: "Idea/Edit/:itemNo",
            element: (
              <ResearchWrite03
                parent="/Research/Idea"
                boardCode={BOARD_CODE.RESEARCH_PROPOSAL}
              />
            ),
          },
          {
            path: "QnA",
            element: <Research04 boardCode={BOARD_CODE.RESEARCH_QNA} />,
          },
          {
            path: "QnA/:itemNo",
            element: <ResearchDetail04 boardCode={BOARD_CODE.RESEARCH_QNA} />,
          },
          {
            path: "QnA/Add",
            element: (
              <NewsUpsert01
                parent="/Research/QnA"
                boardCode={BOARD_CODE.RESEARCH_QNA}
                hasVideoUrl
              />
            ),
          },
          {
            path: "QnA/Edit/:itemNo",
            element: (
              <NewsUpsert01
                parent="/Research/QnA"
                boardCode={BOARD_CODE.RESEARCH_QNA}
                hasVideoUrl
              />
            ),
          },
        ],
      },

      // Privacy
      {
        path: "Public",
        element: <CommonLayout />,
        children: [
          {
            path: "Privacy",
            element: <Privacy />,
          },
          {
            path: "Term",
            element: <Term />,
          },
        ],
      },
    ],
  },
]);

export default routePath;
